module.exports = __webpack_public_path__ + "img/pie.875f7af2.svg";